import { Directive, ElementRef, OnInit } from '@angular/core';
import { IonImgCacheService } from '../ionic2-img-cache/ion-img-cache.service';

@Directive({
  selector: '[ion-img-cache]'/*,
  providers: [IonImgCacheService]*/
})
export class IonImgCacheDirective implements OnInit {
  constructor(
    private el: ElementRef,
    private ionImgCacheService: IonImgCacheService) {
    // Enable CORS.
    el.nativeElement.crossOrigin = 'Anonymous';
  }

  ngOnInit(): void {
    this.ionImgCacheService.cache(this.el.nativeElement);
  }
}



// WEBPACK FOOTER //
// ./src/modules/ionic2-img-cache/ion-img-cache.directive.ts